module.exports = __webpack_public_path__ + "img/interface OneB Player_6.78f2f1ed.jpg";